import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { CustomIcon, CustomIconSet } from '@social-solutions/ssg-forms';
import { dateUtilities } from '../../common';
import './messages.scss';

export class SingleMessage extends Component {

  /** Determines if the message has been published since the last time the user viewed messages */
  isNewMessage() {
    const { item, messageViewDateUtc } = this.props;
    if(!item || !item.publishAtUtc) {
      return false;
    }

    if(!messageViewDateUtc) {
      return true;
    }

    const viewDate = new Date(messageViewDateUtc);
    const publishDate = new Date(item.publishAtUtc);
    const publishedUtcDate = dateUtilities.convertToUtc(publishDate);
    return viewDate < publishedUtcDate;
  }

    // The nvda support div is used to allow non-sighted users to tab to the message and have the contents read (it is not visible to sighted users)
  render() {
    const { item, handleDismiss } = this.props;
    var date = dateUtilities.getUserFriendlyFormatFromJson(item.publishAtUtc);
    return (
      <div key={item.id} id='message' className="message ssg-forms-text normal">
        <div
          role="gridcell" // prevents issue in nvda (sometimes button would not read the dismiss button label when tabbing from this)
          id="nvda-support"
          tabIndex={0}
          className="skip"
          aria-label={date + ': ' + item.content}>
        </div>
        <span id='date' className="message-date">{date}</span>
        {this.isNewMessage() ? <span id='new-indicator' className="message-new">NEW</span> : null}
        <span id='content' className="message-text">{item.content}</span>
        { item.isDismissable ? (
          <button
            id='closeButton'
            className='ssg-forms-icon-btn message-dismiss-btn'
            title="Dismiss"
            aria-label={'dismiss'}
            onClick={e => handleDismiss(item.id)}>
            <CustomIcon iconChoice={CustomIconSet.ic_remove_18x18}/>
          </button>
        ) : null}
      </div>
    );
  }
}

SingleMessage.propTypes = {
  item: PropTypes.object,
  messageViewDateUtc: PropTypes.string,
  handleDismiss: PropTypes.func,
};

export default SingleMessage;



// WEBPACK FOOTER //
// src/dashboard/messages/single-message.js